import commonMapping from "@/mapping/common";

const city_list = [{ config: "any_city", label: "any_city", value: "Any City" }];

const proto_list = [
  { config: "tcp", label: "TCP", value: "TCP" },
  { config: "udp", label: "UDP", value: "UDP" },
];

export const vpnClient = {
  enable: commonMapping.intToBoolean,
  any_city: city_list,
  proto: proto_list,
};

export default vpnClient;
